import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Link} from "react-router-dom";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import { SelectionMode } from "vott-ct/lib/js/CanvasTools/Interface/ISelectorSettings";
import HtmlFileReader from "../../../../common/htmlFileReader";
import { strings } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, IApplicationState,
    IAppSettings, IAsset, IAssetMetadata, IProject, IRegion,
    ISize, ITag, IAdditionalPageSettings, AppError, ErrorCode,IAuthenticationState,
} from "../../../../models/applicationState";
import { IToolbarItemRegistration, ToolbarItemFactory } from "../../../../providers/toolbar/toolbarItemFactory";

import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import { ToolbarItemName } from "../../../../registerToolbarimg";
import { AssetService } from "../../../../services/assetService";
import { AssetPreview } from "../../common/assetPreviewimg/assetPreview";
import { KeyboardBinding } from "../../common/keyboardBinding/keyboardBinding";
import { KeyEventType } from "../../common/keyboardManager/keyboardManager";
import { TagInput } from "../../common/tagInputimg/tagInput";
import { ToolbarItem } from "../../toolbarimg/toolbarItem";
import Canvas from "./canvas";
import CanvasHelpers from "./canvasHelpers";
import "./editorPage.scss";
import EditorSideBar from "./editorSideBar";
import { EditorToolbar } from "./editorToolbar";
import Alert from "../../common/alertimg/alert";
import Confirm from "../../common/confirmimg/confirm";
import { ActiveLearningService } from "../../../../services/activeLearningService";
import { toast } from "react-toastify";
import HeaderComponent from "../header/header";
import ModalHeader from "../header/subHeader";
//import ModalHeader from "../header/subHeader";
import ODModalHeader from "../header/ODsubHeader";
import { PrimaryButton } from "office-ui-fabric-react";
import { getPrimaryGreenTheme, getPrimaryRedTheme } from "../../../../common/themes";
import { throttle } from "../../../../common/utils";
import { constants } from "../../../../common/constants";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";
import size from "lodash/size";
import { Div } from "@tensorflow/tfjs";


//new
import IFilesUploadingAction, * as filesUploadingAction from "../../../../redux/actions/filesUploadingAction";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";

/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IEditorPageProps extends RouteComponentProps, React.Props<EditorPageOD> {
    project: IProject;
    recentProjects: IProject[];
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    loggedInUser: IAuthenticationState;
    loadAnnotateFiles: IAsset[];
    uploadFilesCount?: number;

}

/**
 * State for Editor Page
 */
export interface IEditorPageState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selection mode to set for canvas tools */
    selectionMode: SelectionMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** The child assets used for nest asset typs */
    childAssets?: IAsset[];
    /** Additional settings for asset previews */
    additionalSettings?: IAdditionalPageSettings;
    /** Most recently selected tag */
    selectedTag: string;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    
    // old code v1 starts

    /** Array of assets in project */
//    assets: IAsset[];
    /** The editor mode to set for canvas tools */
  //  editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    //selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    //selectedRegions?: IRegion[];
    /** Most recently selected tag */
    //selectedTag: string;
    /** Tags locked for region labeling */
    //lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    //thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
   // isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    //showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    //hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    isRunningOCRs?: boolean;
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isError?: boolean;
    errorTitle?: string;
    tableName: string;
    showTableInput: boolean;
    errorMessage?: string;
    tableColumns: any[];
    columnName: ITag;
    columnNames: ITag[];
    //tableRows: ITableTag[];
    tableData: any[];
    tableBindedColumns: any[];
    tableBindedRows: any[];
    labelValuesAsTable: any[];
    tags: ITag[];
    ocrFilesList: any[];
    labelFilesList: any[];
    selectedOcrFile: any;
    listOfBlobFiles: any;
    showLoaderForFiles: boolean;
    allFilesAreLoaded: boolean;
    userId: string;
    uploadFilesCount: number;
    isProjectSaved:boolean;
    isProjectExported:boolean;
   // uploadFilesCount: number;

    //// old code v1 ends


}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        appSettings: state.appSettings,

       // generatedOcrContentsData: state.selectedOcrFiles,
        loggedInUser: state.loggedInUser,
        loadAnnotateFiles: state.loadAllFiles,
        //loadAnnotateFiles: state.loadAllFiles,
        //uploadFilesCount: state.uploadFilesCount,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),

        // old code start
        filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),       
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),       
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
        //old code end

    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class EditorPageOD extends React.Component<IEditorPageProps, IEditorPageState> {
    public state: IEditorPageState = {
        selectedTag: null,
        lockedTags: [],
        selectionMode: SelectionMode.RECT,
        assets: [],
        childAssets: [],
        editorMode: EditorMode.Rectangle,
        additionalSettings: {
            videoSettings: (this.props.project) ? this.props.project.videoSettings : null,
            activeLearningSettings: (this.props.project) ? this.props.project.activeLearningSettings : null,
        },
        thumbnailSize: this.props.appSettings.thumbnailSize || { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,

        // old code from v1 start
        userId: null,
      //  selectedTag: null,
        //lockedTags: [],
        //tableRows: [],
        tableColumns: [],
        tableName: null,
        tags: [],
        columnName: null,
        columnNames: [],
        //assets: [],
        labelValuesAsTable: [],
        showTableInput: true,
        tableBindedColumns: [],
        tableBindedRows: [],
        tableData: [],
        labelFilesList: [],
        ocrFilesList: [],
        //editorMode: EditorMode.Select,
        //thumbnailSize: { width: 175, height: 155 },
        //isValid: true,
        //showInvalidRegionWarning: false,
        tagsLoaded: false,
        //hoveredLabel: null,
        selectedOcrFile: null,
        listOfBlobFiles: [],
        showLoaderForFiles: false,
        allFilesAreLoaded: false,
        uploadFilesCount: null,
        isProjectSaved:false,
        isProjectExported:false,
        // old code from v1 start
    };

    private activeLearningService: ActiveLearningService = null;
    private loadingProjectAssets: boolean = false;
    private toolbarItems: IToolbarItemRegistration[] = ToolbarItemFactory.getToolbarItems();
    private canvas: RefObject<Canvas> = React.createRef();
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();

    public async componentDidMount() {
       
        window.addEventListener("focus", this.onFocused);
      
        const projectId = this.props.match.params["projectId"];
        //
        const projectName = this.props.match.params["projectName"];
       
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });
        //
        
     //  debugger;
        if (this.props.project) {
            console.log("with project props:");
            await this.loadProjectAssets();
        } else if (projectId) {
           // const project = this.props.recentProjects.find((project) => project.id === projectId);
            //await this.props.actions.loadProject(project);

            console.log("with project id:");
           const recentProject =await this.props.recentProjects.find((project) => project.id === projectId);
           const projectCopy =await Object.assign({}, recentProject);
                       projectCopy.folderPath =`${projectName}-${userId}/training`;
                       projectCopy.tags = projectCopy.tags;
                       projectCopy.isProjectExported=false;
                       projectCopy.isProjectSaved=false;
                      
           await this.props.actions.saveProject(projectCopy, false, false);
            await this.props.actions.loadProject(projectCopy);
            await this.props.actions.updateProjectTagsFromFiles(this.props.project);
           

        }
       this.activeLearningService = new ActiveLearningService(this.props.project.activeLearningSettings);

           
       // old code from v1 start
      // window.addEventListener("focus", this.onFocused);
       //this.isUnmount = false;
      // const projectId = this.props.match.params["projectId"];
      // const projectName = this.props.match.params["projectName"];
      // const user = this.props.loggedInUser;
       //const userId = user.user.oid;
       //this.setState({ userId });
      /* if (this.props.project) {
           this.loadProjectAssets();
       } else if (projectId) {
           const recentProject = await this.props.recentProjects.find((project) => project.id === projectId);
           const projectCopy = await Object.assign({}, recentProject);
           projectCopy.folderPath = `${projectName}-${userId}/training`;
           projectCopy.tags = projectCopy.tags;
           await this.props.actions.saveProject(projectCopy, false, false);
           await this.props.actions.loadProject(projectCopy);
           await this.props.actions.updateProjectTagsFromFiles(this.props.project);
           this.setState({ tagsLoaded: true });
       }*/


       //

       

       
       
       //
       this.getFilesFromBlob();

       // // old code from v1 end

    }

    
    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
        this.props.actions.loadBlobs(projectCopy, "training");
    }


    public async componentDidUpdate(prevProps: Readonly<IEditorPageProps>, prevState) {

        //

        if (this.props.loadAnnotateFiles !== prevProps.loadAnnotateFiles) {
            await this.loadProjectAssets();
                    } else {
                        localStorage.setItem("filesLengthFromModel", prevProps.loadAnnotateFiles.length.toString())
                    }
            
        //
/*
        if (this.props.project && this.state.assets.length === 0) {
            await this.loadProjectAssets();
        }*/

        // Navigating directly to the page via URL (ie, http://vott/projects/a1b2c3dEf/edit) sets the default state
        // before props has been set, this updates the project and additional settings to be valid once props are
        // retrieved.
        if (this.props.project && !prevProps.project) {
            this.setState({
                additionalSettings: {
                    videoSettings: (this.props.project) ? this.props.project.videoSettings : null,
                    activeLearningSettings: (this.props.project) ? this.props.project.activeLearningSettings : null,
                },
            });
        }

        if (this.props.project && prevProps.project && this.props.project.tags !== prevProps.project.tags) {
            this.updateRootAssets();
        }

        //
        if (prevProps.uploadFilesCount && prevProps.uploadFilesCount !== prevState.uploadFilesCount) {
            prevState.uploadFilesCount = prevProps.uploadFilesCount;
            this.getFilesFromBlob();
        }
        
        if (this.props.loadAnnotateFiles !== prevProps.loadAnnotateFiles) {
            await this.loadProjectAssets();
        } else {
            localStorage.setItem("filesLengthFromModel", prevProps.loadAnnotateFiles.length.toString())
        }

        //
    }

    
    public componentWillUnmount() {
     //   this.isUnmount = true;
       // clearInterval(this.timeInterval);
        window.removeEventListener("focus", this.onFocused);
    }


    public render() {
        
        const { project } = this.props;
        const { assets, selectedAsset } = this.state;
      //  const rootAssets = assets.filter((asset) => !asset.parent);
        const rootAssets = assets ;///.filter((asset) => !asset.parent);
       // const routeUrl = `/upload-files/${this.props.match.params["projectName"]}/${this.props.match.params["schema"]}/${this.props.match.params["projectId"]}`;
       // const routeUrl = `/upload-files/${this.props.match.params["projectName"]}/${this.props.match.params["schema"]}/${this.props.match.params["type"]}/${this.props.match.params["projectId"]}`;
          
        const routeUrl = `/upload-files/${this.props.match.params["projectName"]}/${this.props.match.params["schema"]}/${this.props.match.params["type"]}/${this.props.match.params["projectId"]}`;
        
         
       

       // const needRunOCRButton = assets.some((asset) => asset.state === AssetState.NotVisited);
        //console.log("needRunOCRButton:"+needRunOCRButton);
     //console.log("selectedAsset:"+ JSON.stringify(selectedAsset));
        //console.log("routeUrl:"+ routeUrl);
       // console.log("toolbarItems:"+ JSON.stringify(this.toolbarItems));      

        if (!project) {
            return (<div className="text-center mt-5">Loading...</div>);
        }
         
        return (
            <>
            
            <HeaderComponent
                history={this.props.history}
                match={this.props.match}
                location={this.props.location} />
                <ODModalHeader
                    history={this.props.history}
                    match={this.props.match}
                    actions={this.props.actions}
                    location={this.props.location}
                    project={this.props.project} />
                    <div className="editor-page-img">

                {[...Array(10).keys()].map((index) => {
                    return (<KeyboardBinding
                        displayName={strings.editorPage.tags.hotKey.apply}
                        key={index}
                        keyEventType={KeyEventType.KeyDown}
                        accelerators={[`${index}`]}
                        icon={"fa-tag"}
                        handler={this.handleTagHotKey} />);
                })}
                {[...Array(10).keys()].map((index) => {
                    return (<KeyboardBinding
                        displayName={strings.editorPage.tags.hotKey.lock}
                        key={index}
                        keyEventType={KeyEventType.KeyDown}
                        accelerators={[`CmdOrCtrl+${index}`]}
                        icon={"fa-lock"}
                        handler={this.handleCtrlTagHotKey} />);
                })}
                <SplitPane split="vertical"
                    defaultSize={this.state.thumbnailSize.width}
                    minSize={100}
                    maxSize={400}
                    paneStyle={{ display: "flex" }}
                    onChange={this.onSideBarResize}
                    onDragFinished={this.onSideBarResizeComplete}>
                    <div className="editor-page-img-sidebar bg-lighter-1">

                  

                    
                           
                    {size(assets) !== 0 ?
                        <EditorSideBar
                            assets={rootAssets}
                            selectedAsset={selectedAsset ? selectedAsset.asset : null}
                            onBeforeAssetSelected={this.onBeforeAssetSelected}
                            onAssetSelected={this.selectAsset}
                            thumbnailSize={this.state.thumbnailSize}
                        />
                        :
                         <Spinner
                        size={SpinnerSize.small}
                        label="Loading Files"
                        ariaLive="off"
                        labelPosition="bottom"
                    />
                    }
                   
  
                   


                    </div>

                    <div className="editor-page-img-content" onClick={this.onPageClick}>
                        <div className="editor-page-img-content-main">
                            <div className="editor-page-img-content-main-header">
                                <EditorToolbar project={this.props.project}
                                    items={this.toolbarItems}
                                    actions={this.props.actions}
                                    onToolbarItemSelected={this.onToolbarItemSelected} />
                            </div>

                            {selectedAsset ?
                            <div className="editor-page-img-content-main-body">
                                {selectedAsset &&
                                    <Canvas
                                        ref={this.canvas}
                                        selectedAsset={this.state.selectedAsset}
                                        onAssetMetadataChanged={this.onAssetMetadataChanged}
                                        onCanvasRendered={this.onCanvasRendered}
                                        onSelectedRegionsChanged={this.onSelectedRegionsChanged}
                                        editorMode={this.state.editorMode}
                                        selectionMode={this.state.selectionMode}
                                        project={this.props.project}
                                        lockedTags={this.state.lockedTags}>
                                        <AssetPreview
                                            additionalSettings={this.state.additionalSettings}
                                            autoPlay={true}
                                            controlsEnabled={this.state.isValid}
                                            onBeforeAssetChanged={this.onBeforeAssetSelected}
                                            onChildAssetSelected={this.onChildAssetSelected}
                                            asset={this.state.selectedAsset.asset}
                                            childAssets={this.state.childAssets} />
                                    </Canvas>
                                }
                            </div>
                            :
                            <Spinner
                                    size={SpinnerSize.large}
                                    label="Loading File To Annotate"
                                    ariaLive="off"
                                    className="mt-5"
                                    labelPosition="bottom"
                                />
    }
                        </div>
                        <div className="editor-page-img-right-sidebar">
                            <TagInput
                                tags={this.props.project.tags}
                                lockedTags={this.state.lockedTags}
                                selectedRegions={this.state.selectedRegions}
                                onChange={this.onTagsChanged}
                                onLockedTagsChange={this.onLockedTagsChanged}
                                onTagClick={this.onTagClicked}
                                onCtrlTagClick={this.onCtrlTagClicked}
                                onTagRenamed={this.confirmTagRenamed}
                                onTagDeleted={this.confirmTagDeleted}
                                cvProjId={this.props.project.cvProjId}
                                onTrainClick={this.onTrainingClicked}
                                isProjectExported = {this.props.project.isProjectExported}
                                isProjectSaved = {this.props.project.isProjectSaved}
                            />
                        </div>
                        <Confirm title={strings.editorPage.tags.rename.title}
                            ref={this.renameTagConfirm}
                            message={strings.editorPage.tags.rename.confirmation}
                            confirmButtonColor="danger"
                            onConfirm={this.onTagRenamed} />
                        <Confirm title={strings.editorPage.tags.delete.title}
                            ref={this.deleteTagConfirm}
                            message={strings.editorPage.tags.delete.confirmation}
                            confirmButtonColor="danger"
                            onConfirm={this.onTagDeleted} />
                    </div>
                </SplitPane>
                <Alert show={this.state.showInvalidRegionWarning}
                    title={strings.editorPage.messages.enforceTaggedRegions.title}
                    // tslint:disable-next-line:max-line-length
                    message={strings.editorPage.messages.enforceTaggedRegions.description}
                    closeButtonColor="info"
                    onClose={() => this.setState({ showInvalidRegionWarning: false })} />
            </div>
        
                
            
        </>
        );
    }

    private onPageClick = () => {
        this.setState({
            selectedRegions: [],
        });
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        }, () => this.canvas.current.forceResize());
    }

    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    
    private onFocused = () => {
        this.loadProjectAssets();
    }


    /**
     * Called when a tag from footer is clicked
     * @param tag Tag clicked
     */
    private onTagClicked = (tag: ITag): void => {
        //debugger;
        this.setState({
            selectedTag: tag.name,
            lockedTags: [],
        }, () => this.canvas.current.applyTag(tag.name));
    }

    /**
     * Open confirm dialog for tag renaming
     */
    /*
    private confirmTagRenamed = (tagName: string, newTagName: string): void => {
        this.renameTagConfirm.current.open(tagName, newTagName);
    }
    
    */

   private confirmTagRenamed = (tagName: ITag, newTagName: ITag): void => {
    this.renameTagConfirm.current.open(tagName, newTagName);
}


    /**
     * Renames tag in assets and project, and saves files
     * @param tagName Name of tag to be renamed
     * @param newTagName New name of tag
     */
    /*
    private onTagRenamed = async (tagName: string, newTagName: string): Promise<void> => {

       
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, tagName, newTagName);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            if (selectedAsset) {
                this.setState({ selectedAsset });
            }
        }
    }
    */
    private onTagRenamed = async (tagName: ITag, newTagName: ITag): Promise<void> => {

       
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, tagName, newTagName);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            if (selectedAsset) {
                this.setState({ selectedAsset });
            }
        }
    }
    

    /**
     * Open Confirm dialog for tag deletion
     */
    private confirmTagDeleted = (tagName: string): void => {
        this.deleteTagConfirm.current.open(tagName);
    }

    /**
     * Removes tag from assets and projects and saves files
     * @param tagName Name of tag to be deleted
     */
    private onTagDeleted = async (tagName: string): Promise<void> => {
        const assetUpdates = await this.props.actions.deleteProjectTag(this.props.project, tagName);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            this.setState({ selectedAsset });
        }
    }

    private onCtrlTagClicked = (tag: ITag): void => {
        const locked = this.state.lockedTags;
        this.setState({
            selectedTag: tag.name,
            lockedTags: CanvasHelpers.toggleTag(locked, tag.name),
        }, () => this.canvas.current.applyTag(tag.name));
    }

    private getTagFromKeyboardEvent = (event: KeyboardEvent): ITag => {
        let key = parseInt(event.key, 10);
        if (isNaN(key)) {
            try {
                key = parseInt(event.key.split("+")[1], 10);
            } catch (e) {
                return;
            }
        }
        let index: number;
        const tags = this.props.project.tags;
        if (key === 0 && tags.length >= 10) {
            index = 9;
        } else if (key < 10) {
            index = key - 1;
        }
        if (index < tags.length) {
            return tags[index];
        }
        return null;
    }

    /**
     * Listens for {number key} and calls `onTagClicked` with tag corresponding to that number
     * @param event KeyDown event
     */
    private handleTagHotKey = (event: KeyboardEvent): void => {
        const tag = this.getTagFromKeyboardEvent(event);
        if (tag) {
            this.onTagClicked(tag);
        }
    }

    private handleCtrlTagHotKey = (event: KeyboardEvent): void => {
        const tag = this.getTagFromKeyboardEvent(event);
        if (tag) {
            this.onCtrlTagClicked(tag);
        }
    }

    /**
     * Raised when a child asset is selected on the Asset Preview
     * ex) When a video is paused/seeked to on a video
     */
    private onChildAssetSelected = async (childAsset: IAsset) => {
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id !== childAsset.id) {
            await this.selectAsset(childAsset);
        }
    }

    /**
     * Returns a value indicating whether the current asset is taggable
     */
    private isTaggableAssetType = (asset: IAsset): boolean => {
        return asset.type !== AssetType.Unknown && asset.type !== AssetType.Video;
    }

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (assetMetadata: IAssetMetadata): Promise<void> => {

        
        // If the asset contains any regions without tags, don't proceed.
        const regionsWithoutTags = assetMetadata.regions.filter((region) => region.tags.length === 0);

        if (regionsWithoutTags.length > 0) {
            this.setState({ isValid: false });
            return;
        }
            
        const initialState = assetMetadata.asset.state;

        // The root asset can either be the actual asset being edited (ex: VideoFrame) or the top level / root
        // asset selected from the side bar (image/video).
        const rootAsset = { ...(assetMetadata.asset.parent || assetMetadata.asset) };

        if (this.isTaggableAssetType(assetMetadata.asset)) {
            assetMetadata.asset.state = assetMetadata.regions.length > 0 ? AssetState.Tagged : AssetState.Visited;
        } else if (assetMetadata.asset.state === AssetState.NotVisited) {
            assetMetadata.asset.state = AssetState.Visited;
        }

        // Update root asset if not already in the "Tagged" state
        // This is primarily used in the case where a Video Frame is being edited.
        // We want to ensure that in this case the root video asset state is accurately
        // updated to match that state of the asset.
        if (rootAsset.id === assetMetadata.asset.id) {
            rootAsset.state = assetMetadata.asset.state;
        } else {
            const rootAssetMetadata = await this.props.actions.loadAssetMetadata(this.props.project, rootAsset);

            if (rootAssetMetadata.asset.state !== AssetState.Tagged) {
                
                rootAssetMetadata.asset.state = assetMetadata.asset.state;
                await this.props.actions.saveAssetMetadata(this.props.project, rootAssetMetadata);
            }

            rootAsset.state = rootAssetMetadata.asset.state;
        }

        // Only update asset metadata if state changes or is different
        if (initialState !== assetMetadata.asset.state || this.state.selectedAsset !== assetMetadata) {
            await this.props.actions.saveAssetMetadata(this.props.project, assetMetadata);
        }

        await this.props.actions.saveProject(this.props.project);

        const assetService = new AssetService(this.props.project);
        const childAssets = assetService.getChildAssets(rootAsset);

        // Find and update the root asset in the internal state
        // This forces the root assets that are displayed in the sidebar to
        // accurately show their correct state (not-visited, visited or tagged)
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((asset) => asset.id === rootAsset.id);
        if (assetIndex > -1) {
            assets[assetIndex] = {
                ...rootAsset,
            };
        }

        this.setState({ childAssets, assets, isValid: true });
    }

    /**
     * Raised when the asset binary has been painted onto the canvas tools rendering canvas
     */
    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
        if (this.props.project.activeLearningSettings.autoDetect && !this.state.selectedAsset.asset.predicted) {
            await this.predictRegions(canvas);
        }
    }

    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
        this.setState({ selectedRegions });
    }

    private onTagsChanged = async (tags) => {
        
        const project = {
            ...this.props.project,
            tags,
        };

       // await this.props.actions.saveProject(project);
        await this.props.actions.saveProject(project, true, false);    
    }

    
    private onTrainingClicked = async (trainingInfo) => {
        
        const project = {
            ...this.props.project,
            trainingInfo,
        };

       // await this.props.actions.saveProject(project);
       await this.props.actions.saveTrainedProject(project,trainingInfo);
    
    }



    private onLockedTagsChanged = (lockedTags: string[]) => {
        this.setState({ lockedTags });
    }

    private onToolbarItemSelected = async (toolbarItem: ToolbarItem): Promise<void> => {

       // debugger;
        switch (toolbarItem.props.name) {
            case ToolbarItemName.DrawRectangle:
                this.setState({
                    selectionMode: SelectionMode.RECT,
                    editorMode: EditorMode.Rectangle,
                });
                break;
            case ToolbarItemName.DrawPolygon:
                this.setState({
                    selectionMode: SelectionMode.POLYGON,
                    editorMode: EditorMode.Polygon,
                });
                break;
            case ToolbarItemName.CopyRectangle:
                this.setState({
                    selectionMode: SelectionMode.COPYRECT,
                    editorMode: EditorMode.CopyRect,
                });
                break;
            case ToolbarItemName.SelectCanvas:
                this.setState({
                    selectionMode: SelectionMode.NONE,
                    editorMode: EditorMode.Select,
                });
                break;
            case ToolbarItemName.PreviousAsset:
                await this.goToRootAsset(-1);
                break;
            case ToolbarItemName.NextAsset:
                await this.goToRootAsset(1);
                break;
            case ToolbarItemName.CopyRegions:
                this.canvas.current.copyRegions();
                break;
            case ToolbarItemName.CutRegions:
                this.canvas.current.cutRegions();
                break;
            case ToolbarItemName.PasteRegions:
                this.canvas.current.pasteRegions();
                break;
            case ToolbarItemName.RemoveAllRegions:
                this.canvas.current.confirmRemoveAllRegions();
                break;
            case ToolbarItemName.ActiveLearning:
                await this.predictRegions();
                break;

                case ToolbarItemName.SaveProject:
                 this.setState({ isProjectSaved: true });
                break;

                case ToolbarItemName.ExportProject:
                 this.setState({ isProjectExported: true });
                break;
        }
    }

    private predictRegions = async (canvas?: HTMLCanvasElement) => {
        canvas = canvas || document.querySelector("canvas");
        if (!canvas) {
            return;
        }

        // Load the configured ML model
        if (!this.activeLearningService.isModelLoaded()) {
            //let toastId: number = null;
            let toastId: any = null;
            try {
                toastId = toast.info(strings.activeLearning.messages.loadingModel, { autoClose: false });
                await this.activeLearningService.ensureModelLoaded();
            } catch (e) {
                toast.error(strings.activeLearning.messages.errorLoadModel);
                return;
            } finally {
                toast.dismiss(toastId);
            }
        }


        // Predict and add regions to current asset
        try {
            const updatedAssetMetadata = await this.activeLearningService
                .predictRegions(canvas, this.state.selectedAsset);

            await this.onAssetMetadataChanged(updatedAssetMetadata);
            this.setState({ selectedAsset: updatedAssetMetadata });
        } catch (e) {
            throw new AppError(ErrorCode.ActiveLearningPredictionError, "Error predicting regions");
        }
    }

    /**
     * Navigates to the previous / next root asset on the sidebar
     * @param direction Number specifying asset navigation
     */
    private goToRootAsset = async (direction: number) => {
        const selectedRootAsset = this.state.selectedAsset.asset.parent || this.state.selectedAsset.asset;
        const currentIndex = this.state.assets
            .findIndex((asset) => asset.id === selectedRootAsset.id);

        if (direction > 0) {
            await this.selectAsset(this.state.assets[Math.min(this.state.assets.length - 1, currentIndex + 1)]);
        } else {
            await this.selectAsset(this.state.assets[Math.max(0, currentIndex - 1)]);
        }
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
        }

        return this.state.isValid;
    }

    private selectAsset = async (asset: IAsset): Promise<void> => {
        // Nothing to do if we are already on the same asset.
       // debugger;
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id === asset.id) {
            return;
        }

        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
            return;
        }

        const assetMetadata = await this.props.actions.loadAssetMetadata(this.props.project, asset);

        console.log("selected asset metadata==>"+JSON.stringify(assetMetadata));
        try {
            if (!assetMetadata.asset.size) {
                const assetProps = await HtmlFileReader.readAssetAttributes(asset);
                assetMetadata.asset.size = { width: assetProps.width, height: assetProps.height };
            }
        } catch (err) {
            console.warn("Error computing asset size");
        }

        this.setState({
            selectedAsset: assetMetadata,
        }, async () => {
            await this.onAssetMetadataChanged(assetMetadata);
        });
    }
    
    private loadProjectAssets = async (): Promise<void> => {
      // debugger;
        if (this.loadingProjectAssets) {
            return;
        }
        this.loadingProjectAssets = true;
        const projectCopy = await Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
        await this.props.actions.saveProject(projectCopy, false, false);
        const rootAssets: IAsset[] = this.props.loadAnnotateFiles;
        if (this.state.assets.length === rootAssets.length
            && this.state.assets.map((asset) => asset.id).join(",") === rootAssets.map((asset) => asset.id).join(",")
            && this.state.assets.every((o, i) => Object.keys(o).length === Object.keys(rootAssets[i]).length && Object.keys(o).every(k => o[k] === rootAssets[i][k]))) {
            this.loadingProjectAssets = false;
            return;
        }
        const lastVisited = await rootAssets.length > 0 && rootAssets.find((asset) => asset.id === projectCopy.lastVisitedAssetId);
        if (this.props.project.fromModel) {
            localStorage.setItem("filesLengthFromModel", rootAssets.length.toString());
        }

        //NEW CALL FOR OD
        const sourceAssets = await this.props.actions.loadODAssets(this.props.project,rootAssets);

        this.setState({
            assets: rootAssets,
        }, async () => {
            await this.props.actions.updateProjectTagsFromFiles(this.props.project);
            this.setState({ tagsLoaded: true });
            await this.props.actions.saveProject(this.props.project, false, false);
            if (rootAssets.length > 0 ) {
                await this.selectAsset(lastVisited ? lastVisited : rootAssets[0]);
            }
            this.loadingProjectAssets = false;
        });
    }


    private loadProjectAssets_OD = async (): Promise<void> => {
        if (this.loadingProjectAssets || this.state.assets.length > 0) {
            return;
        }

        //debugger;
        this.loadingProjectAssets = true;

        // Get all root project assets
        const rootProjectAssets = _.values(this.props.project.assets)
            .filter((asset) => !asset.parent);

          //  console.log("load asset:"+JSON.stringify( this.props.loadAnnotateFiles));
        // Get all root. assets from source asset provider
       const sourceAssets = await this.props.actions.loadAssets(this.props.project);
      // console.log("sourceAssets:"+JSON.stringify( sourceAssets1));


      //  const sourceAssets =  this.props.loadAnnotateFiles;

       // console.log("sourceAssets:"+JSON.stringify( sourceAssets));
        // Merge and uniquify
        const rootAssets = _(rootProjectAssets)
            .concat(sourceAssets)
            .uniqBy((asset) => asset.id)
            .value();

        const lastVisited = rootAssets.find((asset) => asset.id === this.props.project.lastVisitedAssetId);

        this.setState({
            assets: rootAssets,

        }, async () => {
            await this.props.actions.updateProjectTagsFromFiles(this.props.project);
            if (rootAssets.length > 0) {
               
                await this.selectAsset(lastVisited ? lastVisited : rootAssets[0]);
            }

            this.loadingProjectAssets = false;
        });
    }

    /**
     * Updates the root asset list from the project assets
     */
    private updateRootAssets = () => {
        const updatedAssets = [...this.state.assets];
        updatedAssets.forEach((asset) => {
            const projectAsset = this.props.project.assets[asset.id];
            if (projectAsset) {
                asset.state = projectAsset.state;
            }
        });

        this.setState({ assets: updatedAssets });
    }

//new

private loadAllOCRs = async () => {
    if (this.state.isRunningOCRs) {
        return;
    }

    const { project } = this.props;
    if (this.state.assets) {
        this.setState({ isRunningOCRs: true });
        try {
            await throttle(
                constants.maxConcurrentServiceRequests,
                this.state.assets.filter((asset) => asset.state === AssetState.NotVisited).map((asset) => asset.id),
                async (assetId) => {
                    // Get the latest version of asset.
                    const asset = this.state.assets.find((asset) => asset.id === assetId);
                    if (asset && asset.state === AssetState.NotVisited) {
                        const { ocrFilesList } = this.state;
                        try {
                            this.updateAssetState(asset.id, true, false);
                            const parts = asset.name.split("/");
                            const fileName = parts.pop() || parts.pop();
                            const data = await this.props.actions.generateOcrForSingleFile(project, fileName, asset);
                            const ocrObject = {};
                            ocrObject["fileName"] = asset.name;
                            ocrObject["ocr"] = data;
                            ocrFilesList.push(ocrObject);
                            this.updateAssetState(asset.id, false, false, AssetState.Visited);
                            this.setState({ ocrFilesList });
                        } catch (err) {
                            this.updateAssetState(asset.id, false, false);
                            this.setState({
                                isError: true,
                                errorTitle: err.title,
                                errorMessage: err.message,
                            });
                        }
                    }
                });
        } finally {
            this.setState({ isRunningOCRs: false });
        }
    }
}

private updateAssetState = (id: string, isRunningOCR: boolean,  isDeleting?: boolean, assetState?: AssetState) => {
    this.setState((state) => ({
        assets: state.assets.map((asset) => {
            if (asset.id === id) {
                const updatedAsset = { ...asset, isRunningOCR, isDeleting };
                if (assetState !== undefined && asset.state === AssetState.NotVisited) {
                    updatedAsset.state = assetState;
                }
                return updatedAsset;
            } else {
                return asset;
            }
        }),
    }), () => {
        if (this.state.selectedAsset && id === this.state.selectedAsset.asset.id) {
            const asset = this.state.assets.find((asset) => asset.id === id);
            if (asset) {
                this.setState({
                    selectedAsset: { ...this.state.selectedAsset, asset: { ...asset } },
                });
            }
        }
    });
}


}
